import {
    ShoppingCart,
    Theaters,
    LocalAtm,
    LocalDrink,
    LocalGasStation,
    LocalHospital,
    LocalPharmacy,
    LocalLaundryService,
    FitnessCenter,
} from '@material-ui/icons';

import {
    Albertsons, AMC, Arco, BankOfAmerica, Chase, Chevron, Cinemark, CoffeeBean, Costco, CVS, DuaneReade,
    Dunkin, Exxon, GoldsGym, Kroger, LAFitness, Mobil, Peets, Ralphs, Regal, Safeway, SavOn, SeventySix, Shell,
    Starbucks, Target, Texaco, TwentyFourHourFitness, Valero, Walgreens, Walmart, WellsFargo, WholeFoods, WinCo,
} from './BrandIcons';

const FEATURE_CONFIG = {
    'Movie Theater': {
        label: 'Theater',
        icon: Theaters,
        brandIcons: {
            AMC,
            Cinemark,
            Regal
        },
    },
    'Groceries': {
        label: 'Groceries',
        icon: ShoppingCart,
        brandIcons: {
            Albertsons,
            Kroger,
            Ralphs,
            Safeway,
            WholeFoods,
            WinCo,
            Costco,
            Target,
            Walmart,
        },
    },
    'Cleaners': {
        label: 'Dry cleaners',
        icon: LocalLaundryService,
    },
    'Gym': {
        label: 'Gym',
        icon: FitnessCenter,
        brandIcons: {
            '24HourFitness': TwentyFourHourFitness,
            GoldsGym,
            LAFitness,
        },
    },
    'ATM': {
        label: 'ATM',
        icon: LocalAtm,
        brandIcons: {
            BankOfAmerica,
            Chase,
            WellsFargo,
        },
    },
    'Coffee': {
        label: 'Coffee',
        icon: LocalDrink,
        brandIcons: {
            CoffeeBean,
            Dunkin,
            Peets,
            Starbucks,
        }
    },
    'Gas Station': {
        label: 'Gas',
        icon: LocalGasStation,
        brandIcons: {
            '76': SeventySix,
            Arco,
            Chevron,
            Exxon,
            Mobil,
            Shell,
            Texaco,
            Valero,
        }
    },
    'Pharmacy': {
        label: 'Pharmacy',
        icon: LocalPharmacy,
        brandIcons: {
            CVS,
            DuaneReade,
            SavOn,
            Walgreens,
        }
    },
    'Hospital': {
        label: 'Medical',
        icon: LocalHospital,
    },
};

export function getBrandIcon(category, name) {
    const normalizedName = (name || '').replace(/\W/, '');
    if(!normalizedName) return null;
    const brandIcons = FEATURE_CONFIG[category] && FEATURE_CONFIG[category].brandIcons
        ? FEATURE_CONFIG[category].brandIcons
        : null;
    const icon = Object.keys(brandIcons || {})
        .reduce((result, pattern)=> {
            const re = new RegExp(pattern, 'i');
            if(re.test(normalizedName)) {
                result = brandIcons[pattern];
            }
            return result;
        }, null);
    return icon;
}

export default FEATURE_CONFIG;
